import React, {useEffect, useState} from 'react'
import {ToastContainer} from 'react-toastify'
import {useNavigate, useParams} from 'react-router-dom'
import notifyToast from '../../../components/Toast/Toast'
import {krajRadnogNaloga, mojeStavkeNaNalogu, pauzirajRadniNalog} from '../../../api/radniNalozi'
import {FmkNalogiStavkeModel} from '../../../models/FmkNaloziModel'
import KrajTable from './components/KrajTable'

const RadniNalogKraj = () => {
    const {id} = useParams()
    const [dataStavka, setDataStavka] = useState<FmkNalogiStavkeModel>()
    const [nalogData, setNalogData] = useState<FmkNalogiStavkeModel>()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        if (id) {
            setLoading(true)
            mojeStavkeNaNalogu({idNaloga: id})
                .then((response) => {
                    setDataStavka(response.data)
                    setNalogData(response.data[0])
                })
                .catch((error) => notifyToast(false, error.message))
                .finally(() => setLoading(false))
        }
    }, [id])

    const handlePauzaRadnogNaloga = async () => {
        try {
            setLoading(true)
            pauzirajRadniNalog({idNaloga: id})
                .then((response) => {
                    notifyToast(true, response.message)
                    setTimeout(() => {
                        navigate(-1)
                    }, 3000)
                })
                .catch((error) => notifyToast(false, error.message))
                .finally(() => setLoading(false))
        } catch (error) {
            console.error('API call failed:', error)
            setLoading(false)
        }
    }

    const handleZavrsiRadniNalog = async () => {
        try {
            setLoading(true)
            krajRadnogNaloga({IdNaloga: id})
                .then((response) => {
                    notifyToast(true, response.message)
                    setTimeout(() => {
                        navigate(-1)
                    }, 1500)
                })
                .catch((error) => notifyToast(false, error.message))
                .finally(() => setLoading(false))
        } catch (error) {
            console.error('API call failed:', error)
            setLoading(false)
        }
    }

    return (
        <div className='container-xxl px-0'>
            <ToastContainer />

            <div className='card shadow-sm mb-6'>
                <div className='card-body p-4 p-md-5'>
                    <div className='d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-4'>
                        <div className='flex-grow-1'>
                            <div className='d-flex align-items-center gap-3 flex-wrap'>
                                <h1 className='fw-bolder text-dark mb-0'>
                                    Radni nalog: <span className='text-primary'>{nalogData?.nalog?.BrojNaloga}</span>
                                </h1>

                                <span className='badge bg-light text-dark border'>
                                    ID: <span className='fw-semibold'>{id}</span>
                                </span>
                            </div>

                            <div className='text-muted mt-2'>
                                Pregled stavki i zavrsetak aktivnog radnog naloga.
                            </div>
                        </div>
                    </div>

                    <div className='alert alert-danger mt-4 mb-0 d-flex align-items-start gap-3'>
                        <i className='fas fa-exclamation-triangle fs-4 mt-1' />
                        <div>
                            <div className='fw-bolder mb-1'>Vazno</div>
                            <div className='mb-0'>
                                Ukoliko pauzirate radni nalog, potrebno je ponovo pokrenuti proizvodnju istog.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='card shadow-sm'>
                <div className='card-body p-4 p-md-5'>
                    <div className='row g-5'>
                        <div className='col-12'>
                            {dataStavka && <KrajTable data={dataStavka} />}
                        </div>

                        <div className='col-12'>
                            <div className='row g-3'>
                                <div className='col-6'>
                                    <button
                                        type='button'
                                        className='btn btn-danger w-100 h-100 py-5 py-md-6 fs-5 fs-md-2 fw-bolder d-flex flex-column flex-sm-row align-items-center justify-content-center'
                                        onClick={handlePauzaRadnogNaloga}
                                        disabled={loading}
                                    >
                                        {!loading ? (
                                            <>
                                                <i className='fas fa-pause mb-2 mb-sm-0 me-sm-3 fs-2' />
                                                <span>Pauziraj Radni Nalog</span>
                                            </>
                                        ) : (
                                            <span className='d-inline-flex align-items-center'>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2' />
                                            </span>
                                        )}
                                    </button>
                                </div>

                                <div className='col-6'>
                                    <button
                                        type='button'
                                        className='btn btn-success w-100 h-100 py-5 py-md-6 fs-5 fs-md-2 fw-bolder d-flex flex-column flex-sm-row align-items-center justify-content-center'
                                        onClick={handleZavrsiRadniNalog}
                                        disabled={loading}
                                    >
                                        {!loading ? (
                                            <>
                                                <i className='fas fa-check mb-2 mb-sm-0 me-sm-3 fs-2' />
                                                <span>Zavrsi Radni Nalog</span>
                                            </>
                                        ) : (
                                            <span className='d-inline-flex align-items-center'>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2' />
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RadniNalogKraj
